import { useEffect } from 'react'

/**
 * Revokes a blob object URL when it changes or the component unmounts.
 * @param {string | null | undefined} url
 */
const useRevokeObjectURL = (url) => {
  useEffect(() => {
    if (typeof url !== 'string' || !url.startsWith('blob:')) {
      return undefined
    }

    return () => {
      window.URL.revokeObjectURL(url)
    }
  }, [url])
}

export default useRevokeObjectURL
